module.exports = {"key":"hello romaninan","submit":"Trimite feedback!","hide":"Ascunde asta","skip":"Treci la următoarea întrebare","placeholder":"Te rugam să ne spui ce părere ai despre aceasta?"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/ro.json
// module id = 444
// module chunks = 0